export const AUTH_ERROR_MESSAGES = {
    MISSING_EMAIL: 'Please provide email.',
    MISSING_PHONE: 'Please provide phone number.',
    MISSING_EMAIL_OR_PHONE: 'Please provide email or phone number.',
    MISSING_CUSTOM_TOKEN: 'Please provide custom token.',
    MISSING_AUTHTYPE_AUTHVALUE: 'authType or authValue is missing.',
    MISSING_FLOW_DATA_ID: 'flowDataID not provided',
};
